import { render, staticRenderFns } from "./DiscountPanel.vue?vue&type=template&id=76f455a8&scoped=true&"
import script from "./DiscountPanel.vue?vue&type=script&lang=js&"
export * from "./DiscountPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f455a8",
  null
  
)

export default component.exports